import type { ReactNode } from "react"

import { SidebarInset } from "@/components/ui/sidebar"
import { cn } from "@/lib/utils"

type ModuleShellProps = {
  children: ReactNode
  className?: string
}

/**
 * Content frame for standalone, rail-less modules (Admin Dashboard, AI
 * Portfolio, Segment Analysis, Local AI Lead).
 *
 * These modules have no app-shell sidebar, so they only need the `SidebarInset`
 * content frame — not a second `SidebarProvider`. `AppLayout` already wraps
 * every route in a `SidebarProvider` (which also provides the Tooltip context),
 * so wrapping again per-page nested a redundant provider that shared the same
 * `sidebar:state` cookie. This renders the same layout — a `flex` wrapper plus a
 * full-width inset — without the duplicate provider.
 */
export function ModuleShell({ children, className }: ModuleShellProps) {
  return (
    <div className="relative flex min-h-full w-full">
      <SidebarInset className={cn("w-full", className)}>{children}</SidebarInset>
    </div>
  )
}
